import React from 'react'
import { today } from './inventoryData';
import { Field, PanelTitle } from './InventoryShared';

function ConsumptionEntryPage({ title = 'Consumption Entry', items }) {
    return (
        <section className='inventory-panel inventory-form-page'>
            <PanelTitle title={title} />
            <div className='inventory-form-grid two-column'>
                <Field label='Item Name' type='select' options={items.map(item => item.name)} />
                <Field label='Quantity Consumed' type='number' placeholder='5' />
                <Field label='Outlet / Area' type='select' options={['Kitchen', 'Bar Counter', 'Main Branch']} />
                <Field label='Date' type='date' defaultValue={today} />
                <Field label='Reference' placeholder='Order / KOT / Manual' />
            </div>
            <div className='inventory-actions sticky'><button>Save Consumption</button></div>
        </section>
    );
}

export default ConsumptionEntryPage
